import { memo } from 'react';
import { MButton } from '@Components/Base';

import styles from './select-employee.module.css';

interface SelectEmployeeComponentProps {
  showModal: () => void;
}

const SelectEmployeeComponent: React.FC<SelectEmployeeComponentProps> = ({
  showModal,
}) => {
  return (
    <MButton
      type="text"
      className={styles.userSelectButton}
      onClick={showModal}
    >
      Select Employee
    </MButton>
  );
};

export default memo(SelectEmployeeComponent);
